// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ms-1";
export var messageSideRight = "_ms-2";
export var subscribeToBackInStockBubbleContainer = "_ms-0";